"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    Globalize.addCultureInfo("en", {
        messages: {
            FilterPane_Close: "Close the filter pane",
            FilterPane_FilterPaneClosedAria: "FilterPane closed.",
            FilterPane_FilterPaneOpenedAria: "FilterPane opened.",
            FilterPane_Filters: "Filters",
            FilterPane_HideFilters: "Hide filters",
            FilterPane_RegionTitle: "Filterpane Region",
            FilterPane_ShowFilters: "Show filters"
        }
    });
    var controls;
    (function (controls) {
        var FilterPane = /** @class */ (function (_super) {
            __extends(FilterPane, _super);
            function FilterPane() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Object.defineProperty(FilterPane.prototype, "FilterManager", {
                /** The FilterManager associated with this FilterPane.
                 * @internal
                 */
                get: function () {
                    if (!this._filterManager && this.Root) {
                        this._filterManager = this.Root.FilterManager;
                    }
                    return this._filterManager;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(FilterPane.prototype, "ShowFiltersButton", {
                /**
                 * The Button that shows/hides the FilterPane.
                 * @internal
                 */
                get: function () {
                    if (!this._showFiltersButton && this.Root && this.Root.element) {
                        var $showFiltersButtonElement = $(this.Root.element).find("[data-dyn-controlname='SystemDefinedShowFiltersButton']");
                        if ($showFiltersButtonElement && $showFiltersButtonElement.length) {
                            this._showFiltersButton = $dyn.context($showFiltersButtonElement[0]);
                        }
                    }
                    return this._showFiltersButton;
                },
                enumerable: false,
                configurable: true
            });
            /**
             * Checks if filter pane is open
             * @internal
             */
            FilterPane.prototype.isOpen = function () {
                return $dyn.value(this.Visible);
            };
            /**
             * Closes filter pane
             * @internal
             */
            FilterPane.prototype.close = function () {
                var _this = this;
                if (this.isOpen()) {
                    $dyn.async(function () {
                        _this.toggleVisibility();
                    });
                    return true;
                }
                return false;
            };
            /**
             * The keydown event handler
             * @internal
             * @param event The key down event.
             */
            FilterPane.prototype.keyDown = function (event) {
                $dyn.util.handleShortcuts(this, event);
            };
            /**
             * Helper function to toggle the visibility of the FilterPane by clicking the 'ShowFilters' button.
             * @internal
             */
            FilterPane.prototype.toggleVisibility = function () {
                var showFiltersButton = this.ShowFiltersButton;
                if (showFiltersButton && showFiltersButton.Clicked && $dyn.value(showFiltersButton.Visible) && $dyn.value(showFiltersButton.Enabled)) {
                    showFiltersButton.Clicked();
                }
            };
            FilterPane.prototype.dispose = function () {
                this.tabbingHandlerDispose();
                _super.prototype.dispose.call(this);
            };
            FilterPane.prototype.init = function (data, element) {
                var _this = this;
                _super.prototype.init.call(this, data, element);
                this.tabbingHandlerDispose = $dyn.util.tabbingContainer(element, $dyn.label("FilterPane_RegionTitle"));
                this.LayoutWidth = $dyn.ui.autoProperty($dyn.layout.Size.available, this, "Width");
                this.LayoutHeight = $dyn.ui.autoProperty($dyn.layout.Size.available, this, "Height");
                $dyn.setValue(this, "Height", $dyn.layout.Size.available);
                $dyn.observe(this.Visible, function (newValue) {
                    // When visibility of the FilterPane changes, update the aria label with this new state.
                    var $element = $(_this.element);
                    var ariaLabel;
                    if (newValue) {
                        ariaLabel = $dyn.label("FilterPane_FilterPaneOpenedAria");
                    }
                    else {
                        // Note that this is not announced as it is no longer the active region.
                        ariaLabel = $dyn.label("FilterPane_FilterPaneClosedAria");
                    }
                    $element.attr("aria-busy", "true");
                    $element.attr("aria-label", ariaLabel);
                    $element.attr("aria-busy", "false");
                });
            };
            return FilterPane;
        }($dyn.ui.Container));
        controls.FilterPane = FilterPane;
        // tslint:disable:object-literal-sort-keys
        var filterPaneShortcuts = {
            Escape: {
                Keys: { keyCode: $dyn.ui.KeyCodes.esc },
                Handler: function () {
                    // Close the FilterPane and prevent from bubbling so the form level enter shortcut (i.e. close form) is prevented.
                    this.toggleVisibility();
                    return true;
                },
                RecordTelemetry: false,
                Description: $dyn.label("FilterPane_Close"),
                Category: $dyn.ui.ShortcutCategory.Close
            },
            Enter: {
                Keys: { keyCode: $dyn.ui.KeyCodes.enter },
                Handler: function () {
                    // Prevent the keyDown from bubbling so the form level enter shortcut (i.e. default action) is prevented.
                    return true;
                },
                RecordTelemetry: false,
                ShowToUser: false
            }
        };
        FilterPane.prototype.Shortcuts = $dyn.extendPrototype(FilterPane.prototype.Shortcuts, filterPaneShortcuts);
        FilterPane.prototype.OptimizedIsOneOfFiltering = false;
        FilterPane.prototype.ShowFilters = null;
        FilterPane.prototype.HideFilters = null;
        FilterPane.prototype.Height = $dyn.layout.Size.available;
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=FilterPane.js.map
